<template>
  <div class="case-item">
    <img :src="data.logo" alt="" />
    <p class="brand-desc">{{ data.brandDesc }}</p>
    <p class="background">
      <span>{{ $t("case.tag1") }}</span>

      <span>{{ data.background }}</span>
    </p>
    <p class="challenge">
      <span>{{ $t("case.tag2") }}</span> <span>{{ data.challenge }}</span>
    </p>

    <div class="carousel">
      <div @click="handleChangePrev" class="arrow arrow-prev">
        <img src="@/assets/images/influenbase-arrow.png" alt="" />
      </div>

      <el-carousel
        :autoplay="false"
        @change="handleChange"
        arrow="never"
        ref="carouselDom"
        indicator-position="none"
      >
        <el-carousel-item v-for="(item, index) in data.carouselData" :key="index">
          <img :src="item" alt="" />
        </el-carousel-item>
      </el-carousel>

      <div @click="handleChangeNext" class="arrow arrow-next">
        <img src="@/assets/images/influenbase-arrow.png" alt="" />
      </div>

      <div class="carousel-dot">
        <span
          v-for="index in data.carouselData.length"
          :key="index"
          :class="{ active: index === activeCarousel + 1 }"
        >
        </span>
      </div>
    </div>

    <div class="footer">
      <div class="footer-left">
        <div class="footer-item" v-for="(item, index) in data.textArr1" :key="index">
          <img src="@/assets/images/influenbase-case-icon1.png" alt="" />
          <p v-html="item"></p>
        </div>
      </div>
      <div class="footer-right">
        <div class="footer-item" v-for="(item, index) in data.textArr2" :key="index">
          <img src="@/assets/images/influenbase-case-icon2.png" alt="" />
          <p v-html="item"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRefs, ref } from "vue";

const props = defineProps<{
  data: {
    logo: string;
    brandDesc: string;
    background: string;
    challenge: string;
    textArr1: string[];
    textArr2: string[];
    carouselData: string[];
  };
}>();

const { data } = toRefs(props);
const activeCarousel = ref(0);
const carouselDom = ref(null);
const handleChange = (val, oldVal) => {
  activeCarousel.value = val;
};
const handleChangePrev = () => {
  carouselDom.value.prev();
};
const handleChangeNext = () => {
  carouselDom.value.next();
};
</script>

<style scoped lang="scss">
.case-item {
  width: 100%;
  margin: auto;
  text-align: left;
  margin-bottom: 110px;
  > img {
    height: 48px;
    margin-bottom: 50px;
  }

  .brand-desc {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 24px;
    color: #402d81;
    margin-bottom: 40px;
  }

  .background {
    display: flex;
    flex-wrap: wrap;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 24px;
    margin-bottom: 17px;
    color: #402d81;
    line-height: 36px;
    margin-bottom: 36px;
    span:nth-child(1) {
      height: 37px;
      background: #e4ceff;
      border-radius: 10px 10px 10px 10px;
      padding: 0 16px;
      margin-right: 20px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 20px;
      color: #9038ff;
      line-height: 36px;
      margin-bottom: 8px;
    }
    span:nth-child(2) {
      width: 100%;
      overflow: hidden;
    }
  }

  .challenge {
    display: flex;
    flex-wrap: wrap;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    color: #402d81;

    span:nth-child(1) {
      height: 37px;
      background: #ffcece;
      border-radius: 10px 10px 10px 10px;
      padding: 0 16px;
      margin-right: 20px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 20px;
      color: #f74c4c;
      line-height: 36px;
      white-space: nowrap;
      margin-bottom: 8px;
    }

    span:nth-child(2) {
      width: 100%;
    }
  }

  .carousel {
    margin: 30px 0 40px 0;
    position: relative;
    height: 484px;
    background: #f7f0fe;
    border-radius: 40px 40px 40px 40px;
    padding: 18px 20px;
    .arrow {
      position: absolute;
      width: 78px;
      height: 78px;
      background: #ffffff;
      box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.07);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      opacity: 0.7;
      transition: all 0.3s;
      top: 50%;
      transform: translateY(-50%);
      z-index: 10;
      &:hover {
        opacity: 1;
      }
      img {
        width: 28px;
        height: 28px;
      }
    }
    .arrow-prev {
      left: -24px;
      img {
        transform: rotate(180deg);
      }
    }
    .arrow-next {
      right: -24px;
    }

    .el-carousel {
      height: 396px !important;
    }
    :deep(.el-carousel__item) {
      height: 396px !important;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        max-width: 100%;
        max-height: 396px;
        border-radius: 20px 20px 20px 20px;
      }
    }

    .carousel-dot {
      display: flex;
      justify-content: center;
      margin-top: 22px;
      span {
        width: 20px;
        height: 8px;
        background: rgba(144, 56, 255, 0.26);
        border-radius: 19px 19px 19px 19px;
        margin-right: 10px;
        transition: all 0.3s;
      }
      span:last-child {
        margin-right: 0;
      }

      .active {
        width: 32px;
        background: #9038ff;
      }
    }
  }

  .footer {
    .footer-left {
      margin-bottom: 50px;
    }
    .footer-item {
      display: flex;
      margin-bottom: 20px;

      img {
        width: 18px;
        height: 18px;
        margin-top: 6px;
        margin-right: 11px;
      }
      :deep(p) {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 24px;
        color: #202020;
        span {
          color: #9038ff;
        }
      }
    }
  }
}
</style>
